import { z } from 'zod'

const booleanSearchParam = z
  .preprocess((value) => value === true || value === 'true', z.boolean())
  .catch(false)

export const questionSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  status: z.enum(['all', 'active', 'inactive']).catch('all'),
  create: booleanSearchParam,
})

export type QuestionSearch = z.infer<typeof questionSearchSchema>

export const defaultQuestionSearch: QuestionSearch = {
  status: 'all',
  create: false,
}
